"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnidadesMedida = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CommonSelect_1 = require("./CommonSelect");
const UnidadesMedida = (props) => ((0, jsx_runtime_1.jsx)(CommonSelect_1.CommonSelect, Object.assign({ options: [
        { value: "AMPOLA", label: "Ampola" },
        { value: "BALDE", label: "Balde" },
        { value: "BANDEJ", label: "Bandeja" },
        { value: "BARRA", label: "Barra" },
        { value: "BISNAG", label: "Bisnaga" },
        { value: "BLOCO", label: "Bloco" },
        { value: "BOBINA", label: "Bobina" },
        { value: "BOMBEAR", label: "Bombona" },
        { value: "CÁPSULAS", label: "Cápsula" },
        { value: "CARRINHO", label: "Cartela" },
        { value: "CENTO", label: "Cento" },
        { value: "CJ", label: "Conjunto" },
        { value: "CM", label: "Centímetro (cm)" },
        { value: "CM2", label: "Centímetro quadrado (cm²)" },
        { value: "CX", label: "Caixa" },
        { value: "CX2", label: "Caixa com 2 unidades" },
        { value: "CX3", label: "Caixa com 3 unidades" },
        { value: "CX5", label: "Caixa com 5 unidades" },
        { value: "CX10", label: "Caixa com 10 unidades" },
        { value: "CX15", label: "Caixa com 15 unidades" },
        { value: "CX20", label: "Caixa com 20 unidades" },
        { value: "CX25", label: "Caixa com 25 unidades" },
        { value: "CX50", label: "Caixa com 50 unidades" },
        { value: "CX100", label: "Caixa com 100 unidades" },
        { value: "DISP", label: "Exibição" },
        { value: "DUZIA", label: "Dúzia" },
        { value: "EMBAL", label: "Embalagem" },
        { value: "FARDO", label: "Fardo" },
        { value: "FOLHA", label: "Folha" },
        { value: "FRASCO", label: "Frasco" },
        { value: "GALAO", label: "Galão" },
        { value: "GF", label: "Garrafa" },
        { value: "GRAMAS", label: "Gramas (g)" },
        { value: "JOGO", label: "Jogo" },
        { value: "KG", label: "Quilograma (kg)" },
        { value: "KIT", label: "Kit" },
        { value: "LATA", label: "Lata" },
        { value: "LITRO", label: "Litro" },
        { value: "M", label: "Metro (m)" },
        { value: "M2", label: "Metro quadrado (m²)" },
        { value: "M3", label: "Metro cúbico (m³)" },
        { value: "MILHEI", label: "Milheiro" },
        { value: "ML", label: "Mililitro (ml)" },
        { value: "MWH", label: "Megawatt hora" },
        { value: "PACOTE", label: "Pacote" },
        { value: "PALETE", label: "Palete" },
        { value: "PARES", label: "Pares" },
        { value: "PC", label: "Peça" },
        { value: "AMIGO", label: "Amigo" },
        { value: "K", label: "Quilate (K)" },
        { value: "RESMA", label: "Resma" },
        { value: "ROLO", label: "Rolo" },
        { value: "SACO", label: "Saco" },
        { value: "SACOLA", label: "Sacola" },
        { value: "TAMBOR", label: "Tambor" },
        { value: "TANQUE", label: "Tanque" },
        { value: "TON", label: "Tonelada" },
        { value: "TUBO", label: "Tubo" },
        { value: "UNID", label: "Unidade" },
        { value: "VASIL", label: "Vasilhame" },
        { value: "VIDRO", label: "Vidro" },
    ] }, props), void 0));
exports.UnidadesMedida = UnidadesMedida;
